import BlockGen from "@/features/triangle-rewards/classes/BlockGen";
import OffersPage from "@/features/offers/OffersPage.vue";

export default (pages, pagesIndex, insertPageNum, unitWidth, unitHeight) => {

    const offerPage = {
        "id": "offersPage",
        "publicationId": "offersPage",
        "name": "offersPage",
        "width": 0,
        "height": 0,
        "isAdPage": false,
        "disclaimer": null,
        "unitWidth": unitWidth,
        "unitHeight": unitHeight,
        "countTowardsPageCount": false,
        "basebars": {
            "desktop": [
                {
                    "resolution": 300,
                    "aspectRatio": 16.1296,
                    "image": "",
                    "url": ""
                },
                {
                    "resolution": 150,
                    "aspectRatio": 16.1296,
                    "image":"",
                    "url": ""
                }],
            "tablet": [
                {
                    "resolution": 300,
                    "aspectRatio": 26.889,
                    "image":"",
                    "url": ""
                },
                {
                    "resolution": 150,
                    "aspectRatio": 26.889,
                    "image":"",
                    "url": ""
                }],
            "mobile": [
                {
                    "resolution": 300,
                    "aspectRatio": 13.936,
                    "image":"",
                    "url": ""
                },
                {
                    "resolution": 150,
                    "aspectRatio": 13.936,
                    "image": "",
                    "url": ""
                }]
        },
        "grids":
            {
                "desktop":
                    {
                        "rowCount": 4,
                        "colCount": 3,
                    },
                "tablet":
                    {
                        "rowCount": 4,
                        "colCount": 3,
                        "fitCols": 5,
                        "style": {
                            "fontSize": "13px"
                        }
                    },
                "mobile":
                    {
                        "rowCount": 3,
                        "colCount": 2,
                        "fitCols": 3,
                        "style": {
                            "fontSize": "13px"
                        }
                    }
            },
        "blocks": [
            BlockGen.GenBlock(3, 4, unitWidth, unitHeight, {}, {id: 'offers_page', type: 'component', component: OffersPage})
        ]
    }
    pages.splice(pagesIndex[insertPageNum], 0, offerPage)

}
